import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */

export const crearOEditarConfiguracion = async (configuracion) => {
    try {
        if (configuracion.id) {
            const resp = await axios.put(
                `${API_URL}/configuraciones/${configuracion.id}`,
                configuracion,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/configuraciones`,
            configuracion,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const actualizarConfiguracion = async (configuracion) => {
    try {
        const resp = await axios.put(
            `${API_URL}/configuraciones/actualizar/${configuracion.id}`,
            configuracion,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerConfiguracionesNomina = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/configuraciones/nomina`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};


